import { Empty, Spin } from "antd";
import { FC, useState } from "react";
import { API } from "../../../api";
import { useInfiniteQuery } from "react-query";
import InfiniteScroll from "react-infinite-scroll-component";
import { Message } from "./Message";
import { useStore } from "../../../config/store";
import { ICleanMessage } from "../../../config/types";
import dayjs from "dayjs";
import locale from 'dayjs/locale/ru';

dayjs.locale(locale);

interface ChatProps {
  height?: string;
  ignore_screen_size?: boolean;
  padding?: string;
}

export const Chat: FC<ChatProps> = ({ height, ignore_screen_size, padding }) => {
  const [totalCount, setTotalCount] = useState(0);
  const { clean } = useStore();


  const { fetchNextPage, data } = useInfiniteQuery({
    queryKey: ['chat', clean?.id],
    queryFn: async ({ pageParam = 1 }) => {
      const result = await API.getCleanMessages({ clean_id: clean?.id }, pageParam);

      if (result) {
        const totalCount = result.total;

        setTotalCount(totalCount);

        return result.messages;
      }

      return [] as ICleanMessage[];
    },
    getNextPageParam: (lastPage, allPages) => {
      if (allPages.reduce((acc, pageArray) => acc + pageArray.length, 0) < totalCount) {
        return allPages.length + 1
      }
      return undefined;
    },
  })

  if (!data) {
    return <Spin />
  }

  const messages = data.pages.flat();

  if (messages.length === 0) {
    return <Empty description="Нет сообщений" />
  }

  let lastDate = dayjs(messages[0].createdAt).format('DD MMMM');

  const formatLocaleDate = (date: string) => dayjs(date).format('DD MMMM')

  const showDate = (date: string, lastMessage: boolean = false) => {
    const formattedDate = formatLocaleDate(date);

    if (lastMessage) {
      return formattedDate;
    }

    if (formattedDate !== lastDate) {
      const savedLastDate = lastDate
      lastDate = formattedDate;

      return savedLastDate;
    }

    return ''
  }

  return (
    <div
      id="scrollableDiv"
      style={{
        padding,
        height: height || 'calc(100vh - 200px)',
        width: '100%',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column-reverse',
      }}
    >
      <InfiniteScroll
        dataLength={messages.length}
        next={fetchNextPage}
        style={{ display: 'flex', flexDirection: 'column-reverse', gap: '5px', overflow: 'hidden', padding: '0 12px 12px 12px' }} //To put endMessage and loader to the top.
        inverse={true} //
        hasMore={messages.length < totalCount}
        loader={<Spin />}
        scrollableTarget="scrollableDiv"
      >
        {messages.map((message, index) => (
          <Message key={index} message={message} show_date={showDate(message.createdAt)} ignore_screen_size={ignore_screen_size === undefined ? true : ignore_screen_size}/>
        ))}
        <div style={{alignSelf: 'center'}}>{formatLocaleDate(messages[messages.length - 1].createdAt)}</div>
      </InfiniteScroll>
    </div>
  );
};
